/** Concierge Self OS Android APK download tracker — always go through here before the file. */
export const SELFOS_BETA = {
  version: '0.2.3-beta',
  versionCode: 5,
  sha256: '69C836DA0C78DFF5ABF170C165E81869704EE5BCE7856A1AD0835D485862E5F5',
  supportEmail: 'support@rolemodel.ai',
} as const;

export function selfOsDownloadUrl(channel: string): string {
  const params = new URLSearchParams({
    version: SELFOS_BETA.version,
    versionCode: String(SELFOS_BETA.versionCode),
    channel,
  });
  return `https://concierge.rolemodel.ai/api/selfos/download?${params.toString()}`;
}

/** Self Phone product page */
export const SELFOS_DOWNLOAD_SELF_PHONE = selfOsDownloadUrl('self-phone');

/** Main-site Essence product page */
export const SELFOS_DOWNLOAD_SELF_LABS_ESSENCE = selfOsDownloadUrl('selflabs-essence');

export const SELF_OS_GITHUB_URL = 'https://github.com/selflabs/SELF-OS';

/** Canonical Essence microsite (custom domain). */
export const ESSENCE_SITE_URL = 'https://essence.selflabs.xyz';
